import { useFormContext, useWatch } from 'react-hook-form';
import {
  DashboardPageFormBody,
  DashboardPageFormField,
  DashboardPageFormToggleSection,
} from '@shigo-ui/dashboard-ui';
import { Checkbox, Input, Label } from '@shigo-ui/ui';

import type { DemandPartnerFormValue } from '../../formSchema';

export function DemandPartnerQpsFields() {
  const { register, formState } = useFormContext<DemandPartnerFormValue>();
  return (
    <DashboardPageFormBody
      title="QPS"
      description="Control the maximum number of bidder requests per second."
    >
      <DashboardPageFormField
        label="Queries per second"
        hint="Allowed range is 0–5787. Setting QPS to zero stops all traffic to this partner. Leave empty (null) to pass all the requests to Demand Partner."
        error={formState.errors.qps?.message}
      >
        <Input
          type="number"
          aria-label="Queries per second"
          min={0}
          max={5787}
          {...register('qps', {
            setValueAs: (value: string | number | null) =>
              value === '' || value === null ? null : Number(value),
          })}
        />
      </DashboardPageFormField>
    </DashboardPageFormBody>
  );
}

export function DemandPartnerCacheFields() {
  const { control, setValue } = useFormContext<DemandPartnerFormValue>();
  const enabled = useWatch({ control, name: 'cacheParamsEnabled' });
  const names = ['cacheUa', 'cacheIp', 'cacheBundle', 'cacheCountry', 'cacheCity'] as const;
  const values = useWatch({ control, name: names });
  return (
    <DashboardPageFormBody
      title="Cache"
      description="Select request properties included in the bidder cache key."
    >
      <DashboardPageFormToggleSection
        checked={enabled}
        label="Cache parameters"
        description="Enable bidder-specific response cache key parameters."
        onCheckedChange={(checked) => {
          setValue('cacheParamsEnabled', checked, { shouldDirty: true });
        }}
      >
        <div className="grid gap-3 sm:grid-cols-2">
          {names.map((name, index) => (
            <Label
              key={name}
              className="border-input flex items-center gap-3 rounded-md border p-3"
            >
              <Checkbox
                checked={values[index] ?? false}
                onCheckedChange={(checked) => {
                  setValue(name, checked === true, { shouldDirty: true });
                }}
              />
              {name.replace('cache', '')}
            </Label>
          ))}
        </div>
      </DashboardPageFormToggleSection>
    </DashboardPageFormBody>
  );
}
